import * as yup from 'yup';

const contentBlockSchema = yup.object({
  type: yup.string().oneOf(['paragraph', 'image', 'images']).required().label('Type'),
  content: yup.string().when('type', {
    is: 'paragraph',
    // biome-ignore lint/suspicious/noThenProperty: used conditionally
    then: (s) => s.required().label('Content'),
    otherwise: (s) => s.optional()
  }),
  src: yup.string().when('type', {
    is: 'image',
    // biome-ignore lint/suspicious/noThenProperty: used conditionally
    then: (s) => s.required().label('Image URL'),
    otherwise: (s) => s.optional()
  }),
  srcs: yup.array(yup.string()).when('type', {
    is: 'images',
    // biome-ignore lint/suspicious/noThenProperty: used conditionally
    then: (s) => s.min(1).label('Images'),
    otherwise: (s) => s.optional()
  }),
  alt: yup.string().optional(),
  caption: yup.string().optional()
});

const articleCardSchema = yup.object({
  title: yup.string().required().label('Title'),
  content: yup.array(contentBlockSchema).default([])
});

const subArticleSchema = yup.object({
  title: yup.string().required().label('Title'),
  articleCards: yup.array(articleCardSchema).default([])
});

export const createUpdateHelpArticleSchema = yup.object({
  title: yup.string().required().label('Title'),
  header: yup.string().required().label('Header'),
  subArticles: yup.array(subArticleSchema).required().default([])
});
